import React from 'react';
import { Card, Result, Button } from 'antd';
import { Link } from 'react-router-dom';

const ResetPassword = () => {
  return (
    <Card className="login-form">
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img
          src="/images/vouchain-logo.png"
          alt="Vouchain Logo"
          style={{ height: 48, marginBottom: 12 }}
        />
      </div>
      <Result
        status="info"
        title="Password Reset"
        subTitle="Please go to the Forgot Password page to reset your password via email verification code."
        extra={
          <Link to="/forgot-password">
            <Button type="primary">Go to Forgot Password</Button>
          </Link>
        }
      />
    </Card>
  );
};

export default ResetPassword;
